import { FC } from 'react';
import * as S from './styles';

export type MarketingMessageCardProps = {
  image: string;
  title: string;
  description: string;
} & S.TitleProps;

const MarketingMessageCard: FC<MarketingMessageCardProps> = ({
  image,
  title,
  description,
  $type,
}) => (
  <S.Card>
    <S.Image width={312} height={311} src={image} alt={$type} />
    <S.Title $type={$type}>{title}</S.Title>
    <S.Description>{description}</S.Description>
  </S.Card>
);

export default MarketingMessageCard;
